import React from 'react';
import { useCss } from 'app/utils/css';
import { useTargetLanguage, useDisplayLanguage } from 'app/components/LanguageContext';
import LessonTranslationToggle from 'app/containers/publishedLesson/LessonTranslationToggle';
import { useIsPublishedLessonPage } from 'app/containers/publishedLesson/PublishedLessonLoadingStatePage';

/**
 * Decides if <LessonTranslationToggle> should be rendered, and adds some padding around it.
 */
const LessonTranslationToggleWrapper: React.FC = () => {
  const isPublishedLessonPage = useIsPublishedLessonPage();
  const targetLanguage = useTargetLanguage();
  const displayLanguage = useDisplayLanguage();

  const showTranslationToggle = isPublishedLessonPage && targetLanguage !== displayLanguage;

  const css = useCss();

  return (
    showTranslationToggle ? (
      <div
        className={css('translationToggle', {
          padding: '0 0.5em',
          display: 'flex',
        })}
      >
        <LessonTranslationToggle />
      </div>
    ) : null
  );
};

export default LessonTranslationToggleWrapper;
